import { render, staticRenderFns } from "./PriceCalculationComponent.vue?vue&type=template&id=09ee805d&"
import script from "./PriceCalculationComponent.vue?vue&type=script&lang=js&"
export * from "./PriceCalculationComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports